exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ":host{display:flex;justify-content:center;align-items:center;min-height:inherit}:host .loader-message{color:#464a4c;display:inline-flex;margin-left:5px;text-transform:uppercase}:host .bounceball{position:relative;display:inline-flex;height:37px;width:15px}:host .bounceball:before{position:absolute;content:\"\";display:block;top:0;width:15px;height:15px;border-radius:50%;background-color:#464a4c;transform-origin:50%;animation:bounce .5s alternate infinite ease}@keyframes bounce{0%{top:30px;height:5px;border-radius:60px 60px 20px 20px;transform:scaleX(2)}35%{height:15px;border-radius:50%;transform:scaleX(1)}to{top:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["./~/bootstrap/scss/_functions.scss","./~/bootstrap/scss/_variables.scss","./src/main/webapp/content/scss/variables.scss"]}!./src/main/webapp/app/account/fc-auth-redirect/fc-auth-redirect.component.scss
// module id = 657
// module chunks = 0